import React from "react";
import CareerRatings from "types/fields/entries/careers/careerRatings";
import CareerPathFragments from "types/fragments/careers/careerPathFragments";

const getJobPostings = (
  jobPostings: CareerPathFragments,
  performanceRatings: CareerRatings
) => {
  var scripts: Array<any> = [];

  // console.log("JOB POSTING!");

  jobPostings.forEach((post, _) => {
    performanceRatings.forEach((rating, index) => {
      scripts.push(
        <script key={"job-posting-" + index} type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "JobPosting",
            title: post.title + " (" + rating.title + ")",
            description: post.metaDescription,
            datePosted: "2021-01-31",
            validThrough: "9999-01-31",
            applicantLocationRequirements: {
              "@type": "Country",
              name: "USA",
            },
            employmentType: "CONTRACTOR",
            jobLocationType: "TELECOMMUTE",
            hiringOrganization: {
              "@type": "Organization",
              name: "delasign",
              sameAs: "https://www.delasign.com",
              logo: "https://delasign.com/delasignBlack.png",
            },
            baseSalary: {
              "@type": "MonetaryAmount",
              currency: "USD",
              value: {
                "@type": "QuantitativeValue",
                value: rating.startingSalary + ".00",
                unitText: "HOUR",
              },
            },
          })}
        </script>
      );
    });
  });

  return scripts;
};

export default getJobPostings;
